var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"geekqoo-loading"},[_c('van-loading',{attrs:{"type":"spinner","size":"0.5rem","color":"#1989fa","vertical":""}},[_vm._v("努力加载中...")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }